export interface TaskStepStatusPayload {
  benchMarkActionCode: string;
  endDate: string;
  isAttorneyNotify: number;
  isBeneficiaryNotify: number;
  isPetitionerNotify: number;
  receiptCategory: string;
  receiptDate: string;
  receiptNumber: string;
  receiptType: string;
  responseCode: string;
  responseNote: string;
  reviewCode: string;
  reviewNote: string;
  startDate: string;
  statusCode: string; // INPROGRESS, COMPLETE
  stepNote: string;
}

export const initialStepStatus: TaskStepStatusPayload = {
  benchMarkActionCode: '',
  endDate: '',
  isAttorneyNotify: 0,
  isBeneficiaryNotify: 0,
  isPetitionerNotify: 0,
  receiptCategory: '',
  receiptDate: '',
  receiptNumber: '',
  receiptType: '',
  responseCode: '',
  responseNote: '',
  reviewCode: '',
  reviewNote: '',
  startDate: '',
  statusCode: '', // INPROGRESS, COMPLETE
  stepNote: ''
};
